import React from "react";
import interpolate from "interpolate";

import AppActions from "../../actions/AppActions";

import EventActions from "../../actions/EventActions";
import FilmActions from "../../actions/FilmActions";
import EventStore from "../../stores/EventStore";
import FilmStore from "../../stores/FilmStore";

/**
 * Faciliates pushing edited tenant info via the admin interface.
 * Used for live previews in the site configurator.
 */
class AdminCommunicator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFirstRequest: true
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired
    };
  }

  componentDidMount() {
    this.listener = window.addEventListener("message", event => {
      if (
        event.origin.indexOf("http://localhost") === 0 ||
        event.origin.indexOf("https://admin.eventive.org") === 0
      ) {
        // ON FIRST REQUEST, PREP FOR FUTURE REQUESTS BY PRELOADING STUFF
        if (this.state.isFirstRequest) {
          EventActions.fetchAll();
          FilmActions.fetchAll();
          this.setState({ isFirstRequest: false });
        }

        // HANDLE ACTUAL REQUESTS
        if (event.data.name === "tenant-update") {
          this.props.onUpdateTenant(event.data.value);
        } else if (event.data.name === "go-to-location") {
          this.props.onCloseLeftNav();
          if (typeof event.data.value === "object") {
            let { location, params } = event.data.value;

            Object.keys(params).map(paramName => {
              if (params[paramName] === "@magic") {
                if (paramName === "eventId") {
                  let keys = Object.keys(EventStore.getState().events);
                  params[paramName] = keys.length && keys[0];
                } else if (paramName === "filmId") {
                  let keys = Object.keys(FilmStore.getState().films);
                  params[paramName] = keys.length && keys[0];
                }
              }
            });

            this.context.router.push(interpolate(location, params));
          } else {
            this.context.router.push(event.data.value);
          }
        } else if (event.data.name === "open-left-nav") {
          this.props.onOpenLeftNav();
        } else if (event.data.name === "close-left-nav") {
          this.props.onCloseLeftNav();
        } else if (event.data.name === "force-event-bucket") {
          AppActions.updateSettings(event.data.value);
        }
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.listener);
  }

  render() {
    return null;
  }
}

export default AdminCommunicator;



// WEBPACK FOOTER //
// ./src/app/components/partials/admin-communicator.jsx